import {BaseEntity} from "./BaseEntity";

export class ServerStatus implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public version?:string,
        public lastSeen?: string,
        public serverType?:string) {
    }
    isRecentlyActive(){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.lastSeen == null ? Date.now() : Date.parse(this.lastSeen);
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        if(diffMinutes < 30)
            return true;
        else
            return false;
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.version = json.version,
        this.lastSeen = json.lastSeen;
        this.serverType = json.serverType;
    }
}
